import { ColumnDef } from '@benzinga/table';

import { SecurityNameCell, SecurityTickerLink } from './TableCells';

export const SecuritiesTradedColumnsDef = [
  {
    cellClass: 'security-cell',
    cellRenderer: ({ data }) => {
      const { company, logo, ticker } = data;
      return <SecurityNameCell logo={logo} name={company} ticker={ticker} />;
    },
    field: 'company',
    headerName: 'Name',
    sortEnabled: true,
    width: 200,
  },
  {
    cellClass: 'security-cell',
    cellRenderer: ({ data }) => <SecurityTickerLink ticker={data.ticker} />,
    field: 'ticker',
    headerName: 'Symbol',
    sortEnabled: true,
    width: 100,
  },
  {
    cellClass: 'security-cell',
    field: 'exchange',
    headerName: 'Exchange',
    sortEnabled: true,
    width: 100,
  },
  {
    cellClass: 'security-cell',
    field: 'total_traded',
    headerName: 'Total Traded',
    sortEnabled: true,
    width: 100,
  },
  {
    cellClass: 'security-cell',
    field: 'total_traders',
    headerName: 'Total Traders',
    sortEnabled: true,
    valueGetter: ({ data }) => {
      return data?.total_traded ?? '';
    },
    width: 100,
  },
] as ColumnDef<any>[];
